var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpgLogoInDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2764_20451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0637 43H5L15.2937 5H34.6262C41.3594 5 45.3724 10.4172 43.5679 17.0807C41.7634 23.7443 34.8147 29.1615 28.0815 29.1615H25.3559L25.1296 29.7634C23.5029 34.0566 19.3552 36.901 14.7174 36.901L13.0637 43V43ZM16.8774 28.9271H24.5856L26.5625 23.7124C27.1388 22.1943 28.604 21.1876 30.2415 21.1876C32.5308 21.1876 34.8901 19.3445 35.5042 17.0807C36.1182 14.8169 34.7554 12.9739 32.4661 12.9739H21.1974L16.8774 28.9218V28.9271Z",
    fill: "#C1FF05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2764_20451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 38,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpgLogoInDark);
export default __webpack_public_path__ + "static/media/ppg_logo_in_dark.6e871c29e188336e8417c45753f14b78.svg";
export { ForwardRef as ReactComponent };